import { useMediaQuery, useTheme } from "@mui/material";
import { AppointmentButtonStatus } from "types/generated/models";
import { Button, Tooltip } from "@powerdiary/components-library/lib";
import { useCallback } from "react";

const BUTTON_WIDTH = "200px";

interface IAppointmentActionButtonProps {
    label: string;
    onClick: () => void;
    dataTestId: string;
    status: AppointmentButtonStatus;
    tooltipText: string;
}

export default function AppointmentActionButton({
    status,
    label,
    onClick,
    tooltipText,
    dataTestId,
}: Readonly<IAppointmentActionButtonProps>) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const renderButton = useCallback(
        () => (
            <Button
                size="extraSmall"
                variant="outlined"
                type="button"
                onClick={status === AppointmentButtonStatus.Disabled ? undefined : onClick}
                sx={{ width: isMobile ? "100%" : BUTTON_WIDTH }}
                data-test-id={dataTestId}
                disabled={status === AppointmentButtonStatus.Disabled}
            >
                {label}
            </Button>
        ),
        [status, isMobile, label, dataTestId, onClick]
    );

    if (status === undefined || status === AppointmentButtonStatus.NotVisible) return null;

    return status === AppointmentButtonStatus.Disabled ? (
        <Tooltip title={tooltipText}>
            <span>{renderButton()}</span>
        </Tooltip>
    ) : (
        renderButton()
    );
}
